/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SCREENS = "screens",
    SCREEN_SHOOT = "screen_shoot",
    BIG_WIN_COUNT_UP = "big_win_count_up",
    BIG_WIN = "big_win",
    WIN_COUNT_UP = "win_count_up",
    ENHANCED_BUTTON = "enhanced_button",
    WIN_PRESENTATION_NUMBERS = "win_presentation_numbers",
    WIN_PRESENTATIONS = "win_presentations",
    POP = "pop",
    NEAR_WIN = "near_win",
    FOREGROUND_TOP = "foreground_top",
    FOREGROUND = "foreground",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    HIGH_SYMBOLS = "high_symbols",
    LOW_SYMBOLS = "low_symbols",
    BACKGROUND = "background"
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    public name:string;

    constructor(name:string) {
        super();
        this.name = name;
    }

    // Note: these only check the direct children.
    public onResize():void {
        this.children.forEach((child:any) => {
            if(child.onResize) {
                child.onResize();
            }
        });
    }

    public onOrientationChanged():void {
        this.children.forEach((child:any) => {
            if(child.onOrientationChanged) {
                child.onOrientationChanged();
            }
        });
    }
}

export class TombstoneRipLayers {

    constructor() {
        for(const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(key), 0);
        }
    }

    public static getLayer(name:string):StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}